<template>
  <q-page padding>
    <div
      class="row col-12 text-brand-5"
      style="cursor: pointer"
      @click="voltar()"
    >
      <q-icon
        style="margin-top: 3px"
        size="sm"
        name="arrow_back_ios"
        class="cursor"
      />
      <p class="text-h6 text-brand-5 text-weight-bold texto-titulo">
        Configurar Certificado
      </p>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div class="col-md-3 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Nome do Treinamento</div>
        <q-input
          v-model="dadosTreinamento.nome"
          dense
          outlined
          class="input"
          disable
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Validade (Dias)</div>
        <q-input
          v-model="dadosTreinamento.validade"
          dense
          outlined
          class="input"
          disable
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Data de Criação</div>
        <q-input
          v-model="dataTreinamentoCriacao"
          dense
          outlined
          class="input"
          disable
          bg-color="brand-7"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm"
          dense
          label="Coletar Assinatura Responsável"
          no-caps
          color="black"
          outline
          icon="history_edu"
          @click="coletarAssinatura = true"
        />
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div>
        <p></p>
        <q-btn
          v-if="editarCertificado"
          dense
          label="Cancelar"
          icon="cancel"
          color="red"
          no-caps
          class="q-mr-md"
          @click="editarCertificado = false"
        />
        <q-btn
          v-if="!editarCertificado"
          dense
          label="Editar Certificado"
          icon="edit"
          color="primary"
          no-caps
          @click="
            (editarCertificado = !editarCertificado),
              recebeDadosCertificadoEditar()
          "
        />
        <q-btn
          v-else
          dense
          label="Salvar"
          icon="check_circle_outline"
          color="positive"
          no-caps
          @click="criarCertificado()"
        />
      </div>
    </div>
    <q-card>
      <div class="q-mt-xl">
        <div class="col-12 container-certificado">
          <div class="row col-12">
            <div style="width: 18%" class="column justify-around top q-pa-md">
              <q-img
                v-if="$store.state.autenticacao.logo.logoImpressao"
                :src="$store.state.autenticacao.logo.logoImpressao"
              />
              <q-img v-else src="../../../../assets/MULTPEX_LOGO.png" />
            </div>
          </div>
          <div
            class="row col-12 justify-center q-mt-md"
            style="text-align: center"
          >
            <q-input
              v-if="editarCertificado"
              dense
              outlined
              style="width: 700px; display: inline-block"
              placeholder="Treinamento"
              v-model="dadosEditados.tituloCertificado"
            />
            <span v-if="!editarCertificado" class="text-h4 text-bold">{{
              dadosCertificado.titulo_certificado
            }}</span>
          </div>
          <div class="row col-12 justify-center q-mt-lg q-mb-xl">
            <div class="row col-7">
              <span class="texto-certificado text-weight-medium"
                >Certificamos que "Colaborador Nome" participou do
                <q-input
                  v-if="editarCertificado"
                  dense
                  outlined
                  style="width: 700px; display: inline-block"
                  placeholder="Treinamento"
                  v-model="dadosEditados.treinamentoNome"
                />
                <b>
                  <span v-if="!editarCertificado"
                    >{{ dadosCertificado.nome_treinamento }}&nbsp;</span
                  >
                </b>
                <q-input
                  v-if="editarCertificado"
                  style="width: 400px; display: inline-block"
                  dense
                  outlined
                  placeholder="Descrição"
                  v-model="dadosEditados.descricaoCertificado"
                />
                <span v-if="!editarCertificado"
                  >{{ dadosCertificado.descricao_certificado }}&nbsp;</span
                >
                <q-input
                  v-if="editarCertificado"
                  style="width: 300px; display: inline-block"
                  dense
                  outlined
                  placeholder="Unidade"
                  v-model="dadosEditados.unidadeNome"
                />
                <span v-if="!editarCertificado">{{
                  dadosCertificado.nome_vendor
                }}</span>
                no dia,
                <span>"Data Treinamento"</span>
                com carga horária de
                <q-input
                  v-if="editarCertificado"
                  style="width: 300px; display: inline-block"
                  dense
                  outlined
                  placeholder="Carga Horaria"
                  v-model="dadosEditados.cargaHoraria"
                />
                <span v-if="!editarCertificado">{{
                  dadosCertificado.carga_horaria
                }}</span>
                de duração.</span
              >
              <span class="texto-certificado text-weight-medium q-mt-md"
                >"Data Aplicação"</span
              >
            </div>
          </div>
          <div
            class="row col-12 justify-around items-center"
            style="margin: 0px 0px 60px 0px"
          >
            <div class="col-2 text-weight-bold">
              <div style="height: 80px"></div>
              <div style="border-top: solid 1px black"></div>
              <div class="row col-12 justify-center q-my-sm">INSTRUTOR</div>
              <div class="row col-12 justify-start q-my-sm">NOME INSTRUTOR</div>
              <div class="row col-12 justify-center"></div>
              <div class="row col-12 justify-start">ID:</div>
            </div>
            <div class="col-2 text-weight-bold">
              <div style="height: 80px"></div>
              <div style="border-top: solid 1px black"></div>
              <div class="row col-12 justify-center q-my-sm">COLABORADOR</div>
              <div class="row col-12 justify-start q-my-sm">
                NOME COLABORADOR
              </div>
              <div class="row col-12 justify-start">ID:</div>
            </div>
            <div class="col-2 text-weight-bold">
              <div
                v-if="dadosCertificado?.url_assinatura_responsavel"
                class="row col-12 justify-center"
              >
                <q-img
                  height="80px"
                  width="140px"
                  id="image"
                  fit="fill"
                  :src="dadosCertificado?.url_assinatura_responsavel"
                />
              </div>
              <div v-else style="height: 80px"></div>
              <div style="border-top: solid 1px black"></div>
              <div class="row col-12 justify-center q-my-sm">
                <q-input
                  v-if="editarCertificado"
                  style="display: inline-block"
                  dense
                  outlined
                  placeholder="Cargo Responsável"
                  v-model="dadosEditados.cargoResponsavel"
                />
                <span v-else>{{
                  dadosCertificado.cargo_responsavel?.toLocaleUpperCase()
                }}</span>
              </div>
              <div class="row col-12 justify-start q-my-sm">
                <q-input
                  v-if="editarCertificado"
                  style="display: inline-block"
                  dense
                  outlined
                  placeholder="Nome Responsável"
                  v-model="dadosEditados.nomeResponsavel"
                />
                <span v-else>{{
                  dadosCertificado.nome_responsavel?.toLocaleUpperCase()
                }}</span>
              </div>
              <div class="row col-12 justify-start">
                <q-input
                  v-if="editarCertificado"
                  style="display: inline-block"
                  dense
                  outlined
                  placeholder="Id Responsável"
                  v-model="dadosEditados.identificacaoResponsavel"
                />
                <span v-else
                  >ID: {{ dadosCertificado.identificacao_responsavel }}</span
                >
              </div>
            </div>
          </div>
          <div style="border-top: solid 5px black"></div>
          <div class="row col-12 justify-center q-mt-xl">
            <q-editor
              v-if="editarCertificado"
              v-model="dadosEditados.tituloProgramatico"
              min-height="3rem"
            />
            <span
              v-else
              v-html="dadosCertificado.titulo_conteudo_programatico"
            ></span>
          </div>
          <div class="row col-12 justify-center q-mt-md">
            <q-editor
              v-if="editarCertificado"
              v-model="dadosEditados.subTituloProgramatico"
              min-height="3rem"
            />
            <span
              v-else
              class="text-h6 text-weight-medium"
              v-html="dadosCertificado.subtitulo_conteudo_programatico"
            ></span>
          </div>
          <div class="row col-12 justify-center q-mt-md">
            <div class="col-9">
              <q-editor
                v-if="editarCertificado"
                v-model="dadosEditados.descricaoConteudoProgramatico"
                :toolbar="[
                  [
                    {
                      label: $q.lang.editor.align,
                      icon: $q.iconSet.editor.align,
                      fixedLabel: true,
                      list: 'only-icons',
                      options: ['left', 'center', 'right', 'justify'],
                    },
                  ],
                  [
                    'bold',
                    'italic',
                    'strike',
                    'underline',
                    'subscript',
                    'superscript',
                  ],
                  [
                    {
                      label: $q.lang.editor.formatting,
                      icon: $q.iconSet.editor.formatting,
                      list: 'no-icons',
                      options: [
                        'p',
                        'h1',
                        'h2',
                        'h3',
                        'h4',
                        'h5',
                        'h6',
                        'code',
                      ],
                    },
                    {
                      label: $q.lang.editor.fontSize,
                      icon: $q.iconSet.editor.fontSize,
                      fixedLabel: true,
                      fixedIcon: true,
                      list: 'no-icons',
                      options: [
                        'size-1',
                        'size-2',
                        'size-3',
                        'size-4',
                        'size-5',
                        'size-6',
                        'size-7',
                      ],
                    },
                    'removeFormat',
                  ],
                  ['quote', 'unordered', 'ordered', 'outdent', 'indent'],

                  ['undo', 'redo'],
                  ['viewsource'],
                ]"
              />
              <span
                v-else
                v-html="dadosCertificado.descricao_conteudo_programatico"
              ></span>
            </div>
          </div>
          <div class="row col-12 justify-end">
            <div style="width: 18%" class="column justify-around top q-pa-md">
              <q-img
                v-if="$store.state.autenticacao.logo.logoImpressao"
                :src="$store.state.autenticacao.logo.logoImpressao"
              />
              <q-img v-else src="../../../../assets/MULTPEX_LOGO.png" />
            </div>
          </div>
        </div>
      </div>
    </q-card>
    <q-dialog v-model="coletarAssinatura">
      <q-card class="card-canvas" style="width: 760px; max-width: 80vw">
        <q-card-section class="q-mx-sm">
          <div class="text-brand-5 text-weight-bold text-h6 q-mb-md">
            Coletar Assinatura Responsável
          </div>
          <Canvas
            @update="receberAssinatura"
            @assinar="enviarAssinaturaResponsavel"
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

import Canvas from "../components/Canvas.vue";
export default {
  components: {
    Canvas,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();

    const dadosEditados = ref({
      treinamentoNome: "Nome do Treinamento",
      subTituloProgramatico: "SUB TITULO",
      tituloProgramatico: "<h4><b>TITULO CONTEÚDO PROGRAMÁTICO</b></h4>",
      descricao: "Descrição do Treinamento",
      descricaoConteudoProgramatico:
        "<ol><li>INTRODUÇÃO À SEGURANÇA COM ELETRICIDADE;</li><li>RISCOS EM INSTALAÇÕES E SERVIÇOS COM ELETRICIDADE;</li><li>TÉCNICAS DE ANÁLISE DE RISCO;</li><li>MEDIDAS DE CONTROLE DE RISCO ELÉTRICO;</li><li>NORMAS TÉCNICAS BRASILEIRAS - NBR DA ABNT: NBR 5410, NBR 14039 e outras;</li><liv>EQUIPAMENTOS DE PROTEÇÃO COLETIVA;</liv><li>EQUIPAMENTOS DE PROTEÇÃO INDIVIDUAL;</li><li>ROTINAS DE TRABALHO -PROCEDIMENTOS, DOCUMENTAÇÃO DE INSTALAÇÕES ELETRICAS;</li><li>RISCOS ADICIONAIS;</li><li>PROTEÇÃO E COMBATE A INCÊNDIOS;</li><li>ACIDENTES DE ORIGEM ELÉTRICA;</li> <li>PRIMEIROS SOCORROS;</li><li>RESPONSABILIDADES;</li><li>ESM;</li></ol>",
      unidadeNome: "Nome da Unidade",
      dataAplicacaoTreinamento: "",
      cargaHoraria: "10",
      nomeResponsavel: "Nome Responsável",
      identificacaoResponsavel: "",
      conformidades: "Teste",
      cargoResponsavel: "Cargo",
      tituloCertificado: "CERTIFICADO",
      descricaoCertificado: "Descrição do Treinamento",
      dataAplicacaoCertificado: "",
    });
    const dadosCertificado = ref({});
    let editarCertificado = ref(false);
    const treinamentoId = route.params.treinamentoId;
    const dadosTreinamento = ref([]);
    const dataTreinamentoCriacao = ref("");
    let coletarAssinatura = ref(false);
    const imagemBase64 = ref(null);

    const detalharCertificado = async () => {
      try {
        const response = await store.dispatch(
          "treinamento/detalharCertificado",
          {
            treinamento_id: treinamentoId,
          }
        );
        if (response.data.response != null) {
          dadosCertificado.value = response.data.response;
          return;
        }
        dadosCertificado.value = {
          nome_treinamento: "Nome do Treinamento",
          nome_vendor: "Nome da Unidade",
          data_aplicacao_treinamento: "03/02/2023",
          nome_responsavel: "Nome Responsável",
          identificacao_responsavel: "",
          cargo_responsavel: "Cargo Responsável",
          carga_horaria: "10",
          conformidades: "",
          titulo_certificado: "CERTIFICADO",
          descricao_certificado: "Descrição do Treinamento",
          data_aplicacao_certificado: "02/02/2023",
          titulo_conteudo_programatico:
            "<h4><b>TITULO CONTEÚDO PROGRAMÁTICO</b></h4>",
          subtitulo_conteudo_programatico: "SUB TITULO",
          descricao_conteudo_programatico:
            "<ol><li>INTRODUÇÃO À SEGURANÇA COM ELETRICIDADE;</li><li>RISCOS EM INSTALAÇÕES E SERVIÇOS COM ELETRICIDADE;</li><li>TÉCNICAS DE ANÁLISE DE RISCO;</li><li>MEDIDAS DE CONTROLE DE RISCO ELÉTRICO;</li><li>NORMAS TÉCNICAS BRASILEIRAS - NBR DA ABNT: NBR 5410, NBR 14039 e outras;</li><liv>EQUIPAMENTOS DE PROTEÇÃO COLETIVA;</liv><li>EQUIPAMENTOS DE PROTEÇÃO INDIVIDUAL;</li><li>ROTINAS DE TRABALHO -PROCEDIMENTOS, DOCUMENTAÇÃO DE INSTALAÇÕES ELETRICAS;</li><li>RISCOS ADICIONAIS;</li><li>PROTEÇÃO E COMBATE A INCÊNDIOS;</li><li>ACIDENTES DE ORIGEM ELÉTRICA;</li> <li>PRIMEIROS SOCORROS;</li><li>RESPONSABILIDADES;</li><li>ESM;</li></ol>",
        };
      } catch (error) {
        console.log(error);
      }
    };

    const criarCertificado = async () => {
      try {
        await store.dispatch("treinamento/criarCertificado", {
          nome_treinamento: dadosEditados.value.treinamentoNome,
          nome_vendor: dadosEditados.value.unidadeNome,
          data_aplicacao_treinamento:
            dadosEditados.value.dataAplicacaoTreinamento,
          nome_responsavel: dadosEditados.value.nomeResponsavel,
          identificacao_responsavel:
            dadosEditados.value.identificacaoResponsavel,
          cargo_responsavel: dadosEditados.value.cargoResponsavel,
          carga_horaria: dadosEditados.value.cargaHoraria,
          conformidades: dadosEditados.value.conformidades,
          titulo_certificado: dadosEditados.value.tituloCertificado,
          descricao_certificado: dadosEditados.value.descricaoCertificado,
          data_aplicacao_certificado:
            dadosEditados.value.dataAplicacaoCertificado,
          titulo_conteudo_programatico: dadosEditados.value.tituloProgramatico,
          subtitulo_conteudo_programatico:
            dadosEditados.value.subTituloProgramatico,
          descricao_conteudo_programatico:
            dadosEditados.value.descricaoConteudoProgramatico,
          treinamento_id: treinamentoId,
        });
        detalharCertificado();
        editarCertificado.value = false;
        quasar.notify({
          message: "Configurações do certificado salvas com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao salvar configurações do certificado",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const voltar = () => {
      router.push({ name: "treinamento-criar-listar" });
    };

    const recebeDadosCertificadoEditar = () => {
      dadosEditados.value = {
        treinamentoNome: dadosCertificado.value.nome_treinamento,
        subTituloProgramatico:
          dadosCertificado.value.subtitulo_conteudo_programatico,
        tituloProgramatico: dadosCertificado.value.titulo_conteudo_programatico,
        descricaoConteudoProgramatico:
          dadosCertificado.value.descricao_conteudo_programatico,
        unidadeNome: dadosCertificado.value.nome_vendor,
        dataAplicacaoTreinamento:
          dadosCertificado.value.data_aplicacao_treinamento,
        cargaHoraria: dadosCertificado.value.carga_horaria,
        nomeResponsavel: dadosCertificado.value.nome_responsavel,
        identificacaoResponsavel:
          dadosCertificado.value.identificacao_responsavel,
        conformidades: dadosCertificado.value.conformidades,
        cargoResponsavel: dadosCertificado.value.cargo_responsavel,
        tituloCertificado: dadosCertificado.value.titulo_certificado,
        descricaoCertificado: dadosCertificado.value.descricao_certificado,
        dataAplicacaoCertificado: "",
      };
    };

    const detalharTreinamento = async () => {
      try {
        const response = await store.dispatch(
          "treinamento/detalharTreinamento",
          {
            treinamento_id: treinamentoId,
          }
        );
        dadosTreinamento.value = response.data;
        if (dadosTreinamento.value.data_criacao) {
          dataTreinamentoCriacao.value = dadosTreinamento.value.data_criacao
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("/");
        }
      } catch (error) {
        console.log(error);
      }
    };

    const receberAssinatura = (value) => {
      imagemBase64.value = value;
    };

    const enviarAssinaturaResponsavel = async () => {
      try {
        await store.dispatch("treinamento/coletarAssinaturaResponsavel", {
          treinamento_uuid: treinamentoId,
          assinatura: imagemBase64.value.split("base64,")[1],
        });
        coletarAssinatura.value = false;
        detalharCertificado();
        quasar.notify({
          message: "Assinatura coletada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro ao coletar assinatura.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(detalharCertificado);
    onMounted(detalharTreinamento);

    return {
      dadosEditados,
      editarCertificado,
      detalharCertificado,
      criarCertificado,
      voltar,
      dadosCertificado,
      recebeDadosCertificadoEditar,
      detalharTreinamento,
      dadosTreinamento,
      dataTreinamentoCriacao,
      coletarAssinatura,
      imagemBase64,
      receberAssinatura,
      enviarAssinaturaResponsavel,
    };
  },
};
</script>

<style scoped>
.container-certificado {
  border: solid 5px black;
  border-radius: 2px;
}
.texto-certificado {
  text-align: justify;
  text-justify: inter-word;
  font-size: 18px;
}
</style>
